(function () {
  'use strict';

  function track(eventName, params) {
    if (!eventName) return;
    var payload = params || {};

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function initTracking() {
    document.querySelectorAll('[data-ppd3-track]').forEach(function (el) {
      el.addEventListener('click', function () {
        track(el.getAttribute('data-ppd3-track'), {
          label: el.getAttribute('data-ppd3-label') || el.textContent.trim(),
          href: el.getAttribute('href') || ''
        });
      });
    });
  }

  function initReveals() {
    var items = document.querySelectorAll('.ppd3-reveal');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initAnchorLinks() {
    document.querySelectorAll('[data-ppd3-anchor]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;

        var target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', href);
      });
    });
  }

  function initActiveNav() {
    var navLinks = Array.prototype.slice.call(document.querySelectorAll('[data-ppd3-nav-link]'));
    if (!navLinks.length || !('IntersectionObserver' in window)) return;

    var sectionIds = navLinks
      .map(function (link) { return link.getAttribute('href'); })
      .filter(Boolean);

    var sections = sectionIds
      .map(function (id) { return document.querySelector(id); })
      .filter(Boolean);

    function setActive(id) {
      navLinks.forEach(function (link) {
        var isActive = link.getAttribute('href') === id;
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setActive('#' + entry.target.id);
        }
      });
    }, {
      rootMargin: '-35% 0px -55% 0px',
      threshold: 0
    });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function setFaqOpen(item, open) {
    var button = item.querySelector('[data-ppd3-faq-button]');
    var answer = item.querySelector('[data-ppd3-faq-answer]');
    if (!button || !answer) return;

    item.classList.toggle('is-open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    answer.hidden = !open;
  }

  function initFaq() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-ppd3-faq]'));
    if (!items.length) return;

    items.forEach(function (item) {
      var button = item.querySelector('[data-ppd3-faq-button]');
      if (!button) return;

      button.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        setFaqOpen(item, !isOpen);
        track('faq_toggle', {
          label: button.textContent.trim(),
          open: !isOpen
        });
      });
    });

    if (window.matchMedia('(min-width: 768px)').matches) {
      setFaqOpen(items[0], true);
    }
  }


  function initDrillCart() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('[data-ppd3-cart-form]'));
    if (!forms.length) return;

    forms.forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var idEl = form.querySelector('[name="id"]');
        var button = form.querySelector('button[type="submit"]');
        var errorEl = form.querySelector('[data-ppd3-cart-error]');
        if (!idEl || !idEl.value) return;

        var originalText = button ? button.textContent : 'Add Station to Cart';
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding to Cart...';
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(idEl.value), quantity: 1 }]
          })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (data) {
                throw new Error(data.description || data.message || 'Unable to add item to cart.');
              });
            }
            return res.json();
          })
          .then(function () {
            track('drill_add_to_cart_success', { variant_id: idEl.value });
            window.location.href = '/cart';
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.textContent = err.message || 'Unable to add item. Please try again.';
              errorEl.hidden = false;
            }
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          });
      });
    });
  }

  function init() {
    initDrillCart();
    initTracking();
    initReveals();
    initAnchorLinks();
    initActiveNav();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
